import { InjectionToken } from '@angular/core';

/**
 * The tenantId this app binary was built for.
 *
 * - Mobile app:  provide `environment.tenantId` in `app.config.ts`
 * - Admin panel: provide `null` (admin users can manage any tenant)
 *
 * Used by `TenantContextService` to select the correct active tenant
 * when a user belongs to multiple tenants simultaneously.
 *
 * @example — app/src/app/app.config.ts
 * ```ts
 * { provide: APP_TENANT_ID, useValue: environment.tenantId }
 * ```
 *
 * @example — admin/src/app/app.config.ts
 * ```ts
 * { provide: APP_TENANT_ID, useValue: null }
 * ```
 */
export const APP_TENANT_ID = new InjectionToken<string | null>('APP_TENANT_ID');
